<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { required, helpers, maxLength } from "vuelidate/lib/validators";
//import Multiselect from "vue-multiselect";
import DropzonePopup from "../../../components/widgets/dropzone-popup";
import config from "../../../config/config";
import { debounce } from "../../../state/helpers";
const priceValidation = helpers.regex("float", /^(\d*([.,](?=\d{1}))?\d+)+((?!\2)[.,]\d\d)?$/);
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  data() {
    return {
      marker: { position: { lat: 23, lng: 72 } },
      config: config,
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 1,
      search: "",
      moment,
      id: "",
      booking: {
        is_cancel: [],
      },
      modelData: {
        id: "",
        name: "",
        address: "",
        city: "",
        code: "",
        price: "",
        start_time: "",
        end_time: "",
        image: "",
        qr_code_image_path: "",
        latitude: "",
        longitude: "",
        uuid_number: "",
        status: "0",
        type: "OCPP",
        charge_type: "AC",
        connector_type: "Type 2 Connector",
        charger_speed: "3.3kW",
        custom_charger_speed: "",
        custom_connector_type: "",
      },
      //qr_code_image_delete_url: process.env.VUE_APP_APIURL + "delete-qr-code-image",
      profile_image: "",
      profile_image_path: "",
      profile_image_delete_url: process.env.VUE_APP_APIURL + "delete-qr-code-image",
      qr_code: {
        image: "",
      },
      searchData: debounce(() => {
        this.getPublicChargers();
        this.init = false;
      }, 500),
      fields: [
        {
          key: "id",
          sortable: true,
          label: "#",
        },
        {
          key: "users",
          sortable: true,
          label: "User",
        },
        {
          key: "name",
          sortable: true,
          label: "Name",
        },
        {
          key: "address",
          sortable: true,
          label: "Address",
        },
        {
          key: "city",
          sortable: true,
          label: "City",
        },
        {
          key: "price",
          sortable: true,
          label: "Price",
        },
        {
          key: "action",
          sortable: false,
          label: "Action",
        },
      ],
    };
  },
  props: ["userId"],
  components: { DropzonePopup },
  validations: {
    modelData: {
      name: { required },
      address: { required },
      city: { required },
      code: { required },
      price: { required, priceValidation, maxLength: maxLength(6) },
      start_time: { required },
      end_time: { required },
      image: {},
      uuid_number: { required },
      status: { required },
      type: { required },
      charge_type: { required },
      connector_type: { required },
      charger_speed: { required },
      custom_charger_speed: { required },
      custom_connector_type: { required },
    },
  },
  computed: {
    ...mapGetters("chargerManagement", [
      "getAllPublicCharger",
      "loading",
      "publicChargerCount",
      "pagination",
      "getShowPublicCharger",
      "getUpdateStatus",
    ]),
  },
  mounted() {
    this.getPublicChargers();
  },
  watch: {
    "modelData.price": function () {
      if (this.modelData.price == 0) {
        this.modelData.price = "";
      }
    },
  },
  methods: {
    ...mapActions("chargerManagement", [
      "getPublicCharger",
      "showPublicCharger",
      "addOrUpdateCharger",
      "deleteCharger",
    ]),
    onUserImagedeleted() {
      this.profile_image = "";
    },
    getPublicChargers(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
        type: "Admin",
      };
      this.getPublicCharger(filters);
    },
    addPublicChargerModel() {
      this.modelData.id = "";
      this.modelData.name = "";
      this.modelData.address = "";
      this.modelData.city = "";
      this.modelData.code = "";
      this.modelData.price = "";
      this.modelData.start_time = "";
      this.modelData.end_time = "";
      this.modelData.latitude = "";
      this.modelData.longitude = "";
      this.modelData.image = "";
      this.modelData.uuid_number = "";
      this.modelData.status = "0";
      this.modelData.type = "OCPP";
      this.modelData.charge_type = "AC";
      this.marker = { position: { lat: 23, lng: 72 } };
      this.$bvModal.show("bv-modal-add-public-charger");
    },
    editPublicCharger(charger_id) {
      this.resetForm();
      var data = {
        id: charger_id,
      };
      this.showPublicCharger(data).then(() => {
        this.modelData.id = this.getShowPublicCharger.id;
        this.modelData.name = this.getShowPublicCharger.name;
        this.modelData.address = this.getShowPublicCharger.address;
        this.modelData.city = this.getShowPublicCharger.city;
        this.modelData.code = this.getShowPublicCharger.zip_code;
        this.modelData.price = this.getShowPublicCharger.price;
        this.modelData.start_time = this.getShowPublicCharger.start_time;
        this.modelData.end_time = this.getShowPublicCharger.end_time;
        this.modelData.latitude = this.getShowPublicCharger.latitude;
        this.modelData.longitude = this.getShowPublicCharger.longitude;
        this.modelData.uuid_number = this.getShowPublicCharger.uuid;
        this.profile_image_path = this.getShowPublicCharger.qr_code_image_path;
        this.profile_image = this.getShowPublicCharger.image;
        this.modelData.status = this.getShowPublicCharger.status;
        this.modelData.type = this.getShowPublicCharger.type;
        this.modelData.charge_type = this.getShowPublicCharger.charge_type;
        if (["3.3kW", "7.4kW"].includes(this.getShowPublicCharger.charger_speed)) {
          this.modelData.charger_speed = this.getShowPublicCharger.charger_speed;
        } else {
          this.modelData.charger_speed = "other";
          this.modelData.custom_charger_speed = this.getShowPublicCharger.charger_speed;
        }
        if (["Type 2 Connector", "15 amp socket"].includes(this.getShowPublicCharger.connector_type)) {
          this.modelData.connector_type = this.getShowPublicCharger.connector_type;
        } else {
          this.modelData.connector_type = "other";
          this.modelData.custom_connector_type = this.getShowPublicCharger.connector_type;
        }
        this.marker.position = {
          lat: parseFloat(this.getShowPublicCharger.latitude),
          lng: parseFloat(this.getShowPublicCharger.longitude),
        };
        this.$bvModal.show("bv-modal-edit-public-charger");
      });
    },
    submitEditForm() {
      this.$v.$touch();
      const fd = new FormData();
      fd.append("id", this.modelData.id);
      fd.append("name", this.modelData.name);
      fd.append("address", this.modelData.address);
      fd.append("city", this.modelData.city);
      fd.append("code", this.modelData.code);
      fd.append("latitude", this.modelData.latitude);
      fd.append("longitude", this.modelData.longitude);
      fd.append("price", this.modelData.price);
      fd.append("start_time", this.modelData.start_time);
      fd.append("end_time", this.modelData.end_time);
      fd.append("uuid", this.modelData.uuid_number);
      fd.append("status", this.modelData.status);
      fd.append("type", this.modelData.type);
      fd.append("is_private", 0);
      fd.append("user_id", 1);
      fd.append("charge_type", this.modelData.charge_type);
      if (this.modelData.charger_speed === "other") {
        fd.append("charger_speed", this.modelData.custom_charger_speed);
      } else {
        fd.append("charger_speed", this.modelData.charger_speed);
      }
      if (this.modelData.connector_type === "other") {
        fd.append("connector_type", this.modelData.custom_connector_type);
      } else {
        fd.append("connector_type", this.modelData.connector_type);
      }
      if (this.modelData.image) {
        fd.append("image", this.modelData.image);
      }
      this.addOrUpdateCharger(fd).then(() => {
        if (this.getUpdateStatus == 200) {
          this.getPublicChargers();
        }
        this.modelData.image = "";
        this.$bvModal.hide("bv-modal-edit-public-charger");
      });
    },
    submitAddForm() {
      this.$v.$touch();
      const fd = new FormData();
      fd.append("name", this.modelData.name);
      fd.append("address", this.modelData.address);
      fd.append("city", this.modelData.city);
      fd.append("code", this.modelData.code);
      fd.append("latitude", this.modelData.latitude);
      fd.append("longitude", this.modelData.longitude);
      fd.append("price", this.modelData.price);
      fd.append("start_time", this.modelData.start_time);
      fd.append("end_time", this.modelData.end_time);
      fd.append("uuid", this.modelData.uuid_number);
      fd.append("status", this.modelData.status);
      fd.append("type", this.modelData.type);
      fd.append("is_private", 0);
      fd.append("user_id", 1);
      fd.append("charge_type", this.modelData.charge_type);
      if (this.modelData.charger_speed === "other") {
        fd.append("charger_speed", this.modelData.custom_charger_speed);
      } else {
        fd.append("charger_speed", this.modelData.charger_speed);
      }
      if (this.modelData.connector_type === "other") {
        fd.append("connector_type", this.modelData.custom_connector_type);
      } else {
        fd.append("connector_type", this.modelData.connector_type);
      }
      if (this.modelData.image) {
        fd.append("image", this.modelData.image);
      }
      this.addOrUpdateCharger(fd).then((response) => {
        console.log(response);
        if (this.getUpdateStatus == 200) {
          this.getPublicChargers();
        }
        this.modelData.image = "";
        this.$bvModal.hide("bv-modal-add-public-charger");
      });
    },
    deletePublicChargers(charger_id) {
      if (confirm("Are You Sure to Delete #" + charger_id + " Public Charger")) {
        const fd = new FormData();
        fd.append("id", charger_id);
        this.deleteCharger(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getPublicChargers();
          }
        });
      }
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getPublicChargers();
    },
    getAddressData: function (addressData, placeResultData) {
      this.modelData.address = placeResultData.formatted_address;
      this.modelData.code = addressData.postal_code ? addressData.postal_code : "";
      this.modelData.latitude = addressData.latitude;
      this.modelData.longitude = addressData.longitude;
      this.modelData.city = addressData.locality;
      this.marker.position = {
        lat: parseFloat(addressData.latitude),
        lng: parseFloat(addressData.longitude),
      };
    },
    resetForm() {
      this.$v.$reset();
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-3">
                <div
                  class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">
                    Sonik charger ({{ publicChargerCount }})
                  </h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select class="custom-select" v-model="perPages" @change="searchData()">
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control"
                              id="search"
                              @input="searchData()"
                              v-model="search"
                              :placeholder="$t('navbar.search.text')"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <b-button
                    class="page-title-right btn btn-success btn-rounded mr-2 add-btn"
                    @click="
                      addPublicChargerModel();
                      $bvModal.show('bv-modal-add-public-charger');
                    "
                    ><i class="mdi mdi-plus mr-1"></i>
                    Add Sonik Charger
                  </b-button>
                  <a
                    :href="config.appurl + 'download-sonik-charger-data'"
                    class="btn btn-primary btn-md btn-rounded ml-1"
                  >
                    Download All Data
                  </a>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :items="getAllPublicCharger"
                  :fields="fields"
                  :busy="loading"
                  class="table-class"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(users)="items">
                    {{ items.item.users ? items.item.users : "" }}
                  </template>
                  <template v-slot:cell(price)="items">
                    {{ items.item.price ? items.item.price : "" }}
                  </template>
                  <template v-slot:cell(action)="items">
                    <b-button
                      @click="editPublicCharger(items.item.id)"
                      class="btn btn-success btn-rounded"
                    >
                      <i class="bx bxs-edit"></i>
                    </b-button>
                    &nbsp;
                    <b-button
                      @click="deletePublicChargers(items.item.id)"
                      class="btn btn-danger btn-rounded"
                    >
                      <i class="bx bx-trash"></i>
                    </b-button>
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllPublicCharger.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No Sonik Charger Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getPublicChargers"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- Add vehicle make Model start -->
    <b-modal id="bv-modal-add-public-charger" size="lg" hide-footer @hidden="resetForm">
      <template #modal-title>Add Sonik Charger</template>
      <form action="#" @submit.prevent="submitAddForm">
        <div class="row">
          <div class="col-sm-6 mb-3">
            <label>Search Address</label>
            <!-- <vue-google-autocomplete
              ref="address"
              id="map"
              classname="form-control"
              placeholder="Type address"
              v-on:placechanged="getAddressData"
            >
            </vue-google-autocomplete> -->
            <div class="search-box d-flex">
              <div class="position-relative w-100">
                <vue-google-autocomplete
                  ref="address"
                  id="map"
                  placeholder="Type address"
                  class="form-control"
                  v-on:placechanged="getAddressData"
                /><i class="fas fa-search search-icon"></i>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label>Name</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Name"
                v-model="$v.modelData.name.$model"
                :class="{ 'is-invalid': $v.modelData.name.$error }"
                name="name"
              />
              <div v-if="$v.modelData.name.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.name.required">Please enter name</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Address</label>
              <input
                id="user_name"
                type="text"
                class="form-control"
                placeholder="Enter Address"
                v-model="$v.modelData.address.$model"
                name="name"
                :class="{ 'is-invalid': $v.modelData.address.$error }"
              />
              <div v-if="$v.modelData.address.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.address.required">Please enter address</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Status</label>
              <select
                v-model="$v.modelData.status.$model"
                class="form-control"
                :class="{ 'is-invalid': $v.modelData.status.$error }"
              >
                <option value="0" selected>Available</option>
                <option value="2">Busy</option>
                <option value="1">Unavailable</option>
                <option value="3">Under Maintenance</option>
              </select>
              <div v-if="$v.modelData.status.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.status.required">Please select status</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>City</label>
              <input
                id="city"
                type="text"
                class="form-control"
                placeholder="Enter City"
                v-model="$v.modelData.city.$model"
                :class="{ 'is-invalid': $v.modelData.city.$error }"
                name="city"
              />
              <div v-if="$v.modelData.city.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.city.required">Please enter city</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Postal Code</label>
              <input
                id="code"
                type="number"
                class="form-control"
                placeholder="Enter Code"
                v-model="$v.modelData.code.$model"
                :class="{ 'is-invalid': $v.modelData.code.$error }"
                name="code"
              />
              <div v-if="$v.modelData.code.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.code.required">Please enter postal code</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Price (/kWh)</label>
              <input
                id="price"
                type="text"
                class="form-control"
                placeholder="Enter Price"
                v-model="$v.modelData.price.$model"
                :class="{ 'is-invalid': $v.modelData.price.$error }"
                name="price"
              />
              <div v-if="$v.modelData.price.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.price.required">Please enter price</span>
                <span v-if="!$v.modelData.price.priceValidation">Price is not correct</span>
                <span v-if="!$v.modelData.price.maxLength">Please enter price maximum 6 digit</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>UUID Number</label>
              <input
                id="uuid_number"
                type="text"
                class="form-control"
                placeholder="Enter UUID Number"
                v-model="$v.modelData.uuid_number.$model"
                :class="{ 'is-invalid': $v.modelData.uuid_number.$error }"
                name="code"
              />
              <div v-if="$v.modelData.uuid_number.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.uuid_number.required">Please enter uuid number</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <b-form-group
                id="start_time"
                label="Start Time"
                label-for="start"
                label-class="required"
              >
                <b-form-input
                  class="form-control"
                  v-model="$v.modelData.start_time.$model"
                  id="start_time"
                  type="time"
                  :class="{ 'is-invalid': $v.modelData.start_time.$error }"
                ></b-form-input>
                <div v-if="$v.modelData.start_time.$error" class="invalid-feedback">
                  <span v-if="!$v.modelData.start_time.required"> Please select start time</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <b-form-group id="end_time" label="End Time" label-for="end" label-class="required">
                <b-form-input
                  class="form-control"
                  v-model="$v.modelData.end_time.$model"
                  id="end_time"
                  type="time"
                  :class="{ 'is-invalid': $v.modelData.end_time.$error }"
                ></b-form-input>
                <div v-if="$v.modelData.end_time.$error" class="invalid-feedback">
                  <span v-if="!$v.modelData.end_time.required"> Please select end time</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Type</label>
              <select
                v-model="$v.modelData.type.$model"
                class="form-control"
                :class="{ 'is-invalid': $v.modelData.type.$error }"
              >
                <option value="OCPP" selected>OCPP</option>
                <option value="BLE">BLE</option>
              </select>
              <div v-if="$v.modelData.type.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.type.required">Please select type</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Charger type</label>
              <select
                v-model="$v.modelData.charge_type.$model"
                class="form-control"
                :class="{ 'is-invalid': $v.modelData.charge_type.$error }"
              >
                <option value="AC" selected>AC</option>
                <option value="DC">DC</option>
              </select>
              <div v-if="$v.modelData.charge_type.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.charge_type.required">Please select type</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Connector Type</label>
              <select
                v-model="$v.modelData.connector_type.$model"
                class="form-control"
                :class="{ 'is-invalid': $v.modelData.connector_type.$error }"
              >
                <option value="Type 2 Connector" selected>Type 2 Connector</option>
                <option value="15 amp socket">15 amp socket</option>
                <option value="other">Other</option>
              </select>
              <div v-if="$v.modelData.connector_type.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.connector_type.required">Please select type</span>
              </div>
            </div>
          </div>
          <div v-if="modelData.connector_type === 'other'" class="col-sm-4">
            <div class="form-group mb-3">
              <label>Enter Connector Type</label>
              <input
                type="text"
                v-model="modelData.custom_connector_type"
                class="form-control"
                placeholder="Enter Charger Speed"
                :class="{ 'is-invalid': $v.modelData.custom_connector_type.$error }"
              />
              <div v-if="$v.modelData.custom_connector_type.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.custom_connector_type.required"
                  >Please enter Connector Type</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Charger Speed</label>
              <select
                v-model="$v.modelData.charger_speed.$model"
                class="form-control"
                :class="{ 'is-invalid': $v.modelData.charger_speed.$error }"
              >
                <option value="3.3kW" selected>3.3kW</option>
                <option value="7.4kW">7.4kW</option>
                <option value="other">Other</option>
              </select>
              <div v-if="$v.modelData.charger_speed.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.charger_speed.required">Please select type</span>
              </div>
            </div>
          </div>
          <div v-if="modelData.charger_speed === 'other'" class="col-sm-4">
            <div class="form-group mb-3">
              <label>Enter Charger Speed</label>
              <input
                type="text"
                v-model="modelData.custom_charger_speed"
                class="form-control"
                placeholder="Enter Charger Speed"
                :class="{ 'is-invalid': $v.modelData.custom_charger_speed.$error }"
              />
              <div v-if="$v.modelData.custom_charger_speed.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.custom_charger_speed.required"
                  >Please enter charger speed</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-6 card">
            <div class="form-group mb-3">
              <h4 class="card-title required">Charger Image</h4>
              <p class="card-title-desc"></p>

              <div class="row mt-n3">
                <div class="col-sm-12">
                  <dropzone-popup
                    type="file"
                    v-model="modelData.image"
                    id="profile_image"
                    acceptedFiles=".jpeg,.jpg,.png"
                    :delete-path="profile_image_delete_url"
                    :class="{ 'is-invalid': $v.modelData.image.$error }"
                    @image-deleted="this.onUserImagedeleted"
                  />
                  <div v-if="$v.modelData.image.$error" class="invalid-feedback cuisine-img">
                    <span v-if="!$v.modelData.image.required">Image is required.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 card">
            <GmapMap
              :center="marker.position"
              :zoom="18"
              map-style-id="roadmap"
              style="width: 100%; height: 170px"
              ref="mapRef"
            >
              <GmapMarker :position="marker.position" :clickable="true" :draggable="true" />
            </GmapMap>
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-add-public-charger');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Add vehicle make Model end -->
    <!-- Edit vehicle make Model start -->
    <b-modal id="bv-modal-edit-public-charger" size="lg" hide-footer @hidden="resetForm">
      <template #modal-title>Edit Sonik Charger</template>
      <form action="#" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-sm-6 mb-3">
            <label>Search Address</label>
            <!-- <vue-google-autocomplete
              ref="address"
              id="map"
              classname="form-control"
              placeholder="Type address"
              v-on:placechanged="getAddressData"
            >
            </vue-google-autocomplete> -->
            <div class="search-box d-flex">
              <div class="position-relative w-100">
                <vue-google-autocomplete
                  ref="address"
                  id="map"
                  placeholder="Type address"
                  class="form-control"
                  v-on:placechanged="getAddressData"
                /><i class="fas fa-search search-icon"></i>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label>Name</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Name"
                v-model="$v.modelData.name.$model"
                :class="{ 'is-invalid': $v.modelData.name.$error }"
                name="name"
              />
              <div v-if="$v.modelData.name.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.name.required">Please enter name</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Address</label>
              <input
                id="user_name"
                type="text"
                class="form-control"
                placeholder="Enter Address"
                v-model="$v.modelData.address.$model"
                name="name"
                :class="{ 'is-invalid': $v.modelData.address.$error }"
              />
              <div v-if="$v.modelData.address.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.address.required">Please enter address</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Status</label>
              <select
                v-model="$v.modelData.status.$model"
                class="form-control"
                :class="{ 'is-invalid': $v.modelData.status.$error }"
              >
                <option disabled value="">Please select one</option>
                <option value="0">Available</option>
                <option value="2">Busy</option>
                <option value="1">Unavailable</option>
                <option value="3">Under Maintenance</option>
              </select>
              <div v-if="$v.modelData.status.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.status.required">Please select status</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>City</label>
              <input
                id="city"
                type="text"
                class="form-control"
                placeholder="Enter City"
                v-model="$v.modelData.city.$model"
                :class="{ 'is-invalid': $v.modelData.city.$error }"
                name="city"
              />
              <div v-if="$v.modelData.city.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.city.required">Please enter city</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Postal Code</label>
              <input
                id="code"
                type="text"
                class="form-control"
                placeholder="Enter Postal Code"
                v-model="$v.modelData.code.$model"
                :class="{ 'is-invalid': $v.modelData.code.$error }"
                name="code"
              />
              <div v-if="$v.modelData.code.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.code.required">Please enter postal code</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Price (/kWh)</label>
              <input
                id="price"
                type="text"
                class="form-control"
                placeholder="Enter Price"
                v-model="$v.modelData.price.$model"
                :class="{ 'is-invalid': $v.modelData.price.$error }"
                name="price"
              />
              <div v-if="$v.modelData.price.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.price.required">Please enter price</span>
                <span v-if="!$v.modelData.price.priceValidation">Price is not correct</span>
                <span v-if="!$v.modelData.price.maxLength">Please enter price maximum 6 digit</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>UUID Number</label>
              <input
                id="uuid_number"
                type="text"
                class="form-control"
                placeholder="Enter UUID Number"
                v-model="$v.modelData.uuid_number.$model"
                :class="{ 'is-invalid': $v.modelData.uuid_number.$error }"
                name="code"
              />
              <div v-if="$v.modelData.uuid_number.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.uuid_number.required">Please enter uuid number</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <b-form-group
                id="start_time"
                label="Start Time"
                label-for="start"
                label-class="required"
              >
                <b-form-input
                  class="form-control"
                  v-model="$v.modelData.start_time.$model"
                  id="start_time"
                  type="time"
                  :class="{ 'is-invalid': $v.modelData.start_time.$error }"
                ></b-form-input>
                <div v-if="$v.modelData.start_time.$error" class="invalid-feedback">
                  <span v-if="!$v.modelData.start_time.required"> Please select start time</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <b-form-group id="end_time" label="End Time" label-for="end" label-class="required">
                <b-form-input
                  class="form-control"
                  v-model="$v.modelData.end_time.$model"
                  id="end_time"
                  type="time"
                  :class="{ 'is-invalid': $v.modelData.end_time.$error }"
                ></b-form-input>
                <div v-if="$v.modelData.end_time.$error" class="invalid-feedback">
                  <span v-if="!$v.modelData.end_time.required"> Please select end time</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Type</label>
              <select
                v-model="$v.modelData.type.$model"
                class="form-control"
                :class="{ 'is-invalid': $v.modelData.type.$error }"
              >
                <option value="OCPP" selected>OCPP</option>
                <option value="BLE">BLE</option>
              </select>
              <div v-if="$v.modelData.type.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.type.required">Please select type</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Charger type</label>
              <select
                v-model="$v.modelData.charge_type.$model"
                class="form-control"
                :class="{ 'is-invalid': $v.modelData.charge_type.$error }"
              >
                <option value="AC" selected>AC</option>
                <option value="DC">DC</option>
              </select>
              <div v-if="$v.modelData.charge_type.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.charge_type.required">Please select type</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Connector Type</label>
              <select
                v-model="$v.modelData.connector_type.$model"
                class="form-control"
                :class="{ 'is-invalid': $v.modelData.connector_type.$error }"
              >
                <option value="Type 2 Connector" selected>Type 2 Connector</option>
                <option value="15 amp socket">15 amp socket</option>
                <option value="other">Other</option>
              </select>
              <div v-if="$v.modelData.connector_type.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.connector_type.required">Please select type</span>
              </div>
            </div>
          </div>
          <div v-if="modelData.connector_type === 'other'" class="col-sm-4">
            <div class="form-group mb-3">
              <label>Enter Connector Type</label>
              <input
                type="text"
                v-model="modelData.custom_connector_type"
                class="form-control"
                placeholder="Enter Charger Speed"
                :class="{ 'is-invalid': $v.modelData.custom_connector_type.$error }"
              />
              <div v-if="$v.modelData.custom_connector_type.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.custom_connector_type.required"
                  >Please enter Connector Type</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Charger Speed</label>
              <select
                v-model="$v.modelData.charger_speed.$model"
                class="form-control"
                :class="{ 'is-invalid': $v.modelData.charger_speed.$error }"
              >
                <option value="3.3kW" selected>3.3kW</option>
                <option value="7.4kW">7.4kW</option>
                <option value="other">Other</option>
              </select>
              <div v-if="$v.modelData.charger_speed.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.charger_speed.required">Please select type</span>
              </div>
            </div>
          </div>
          <div v-if="modelData.charger_speed === 'other'" class="col-sm-4">
            <div class="form-group mb-3">
              <label>Enter Charger Speed</label>
              <input
                type="text"
                v-model="modelData.custom_charger_speed"
                class="form-control"
                placeholder="Enter Charger Speed"
                :class="{ 'is-invalid': $v.modelData.custom_charger_speed.$error }"
              />
              <div v-if="$v.modelData.custom_charger_speed.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.custom_charger_speed.required"
                  >Please enter charger speed</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-6 card">
            <div class="form-group mb-3">
              <h4 class="card-title required">Charger Image</h4>
              <p class="card-title-desc"></p>
              <div class="row mt-n3">
                <div class="col-sm-12">
                  <dropzone-popup
                    type="file"
                    v-model="modelData.image"
                    id="profile_image"
                    acceptedFiles=".jpeg,.jpg,.png"
                    :editable-images="profile_image"
                    :media-path="profile_image_path + 'original'"
                    :delete-path="profile_image_delete_url"
                    @image-deleted="this.onUserImagedeleted"
                  />
                  <div v-if="$v.modelData.image.$error" class="invalid-feedback cuisine-img">
                    <span v-if="!$v.modelData.image.required">Image is required.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 card">
            <GmapMap
              :center="marker.position"
              :zoom="18"
              map-style-id="roadmap"
              style="width: 100%; height: 170px"
              ref="mapRef"
            >
              <GmapMarker :position="marker.position" :clickable="true" :draggable="true" />
            </GmapMap>
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-edit-public-charger');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Edit vehicle make Model end -->
  </div>
</template>
<style>
.multiselect {
  width: 100% !important;
}
.btn-success {
  background-color: #ff3350 !important;
  border-color: #ff3350 !important;
}
.table-class {
  table-layout: fixed;
}
.table-class th:first-child {
  width: 50px;
}
.table-class th:nth-child(2n) {
  width: 150px;
}
.table-class th:nth-child(5n) {
  width: 150px;
}
.table-class th:nth-child(6n) {
  width: 100px;
}
.table-class th:nth-child(4n) {
  width: 200px;
}
</style>
